import { env } from 'config';

const url = `${env.apiUrl}/v1/order-requisites`;

const getQrCodeUrl = (orderId: string) => `${url}/${orderId}/qr-code`;

const formatPaymentLink = (paymentLink: string) => {
  try {
    const url = new URL(paymentLink);
    return url.hostname;
  } catch {
    return paymentLink;
  }
};

export const orderRequisitesUtils = {
  getQrCodeUrl,
  formatPaymentLink,
};
